import { FOOTER_LINKS } from '@/data/content';

function SocialIcon({ type }: { type: 'twitter' | 'instagram' | 'linkedin' }) {
  const shared = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  };

  switch (type) {
    case 'twitter':
      return (
        <svg {...shared}>
          <path d="M4 4l6.5 8L4 20h2l5.5-6.5L16 20h4l-7-8.5L19.5 4H18l-5 6L9 4H4z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg {...shared}>
          <rect x="2" y="2" width="20" height="20" rx="5" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'linkedin':
      return (
        <svg {...shared}>
          <rect x="2" y="2" width="20" height="20" rx="5" />
          <path d="M8 11v5" />
          <path d="M8 8v.01" />
          <path d="M12 16v-5" />
          <path d="M16 16v-3a2 2 0 0 0-4 0" />
        </svg>
      );
  }
}

const linkSections = [
  { title: 'Product', links: FOOTER_LINKS.product },
  { title: 'Company', links: FOOTER_LINKS.company },
  { title: 'Legal', links: FOOTER_LINKS.legal },
];

export function Footer() {
  return (
    <footer className="bg-gray-900 py-16 text-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col gap-12 md:flex-row md:justify-between">
          {/* Brand */}
          <div className="max-w-xs">
            <span className="text-xl font-bold">Run2Sale</span>
            <p className="mt-3 text-sm text-gray-400">
              The faster you get there, the more you save.
            </p>
          </div>

          {/* Link columns */}
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:gap-12">
            {linkSections.map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold uppercase tracking-wider text-gray-400">
                  {section.title}
                </h4>
                <ul className="mt-4 space-y-3">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-gray-300 transition-colors hover:text-white"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Social + copyright */}
        <div className="mt-12 flex flex-col items-center gap-4 border-t border-gray-800 pt-8 md:flex-row md:justify-between">
          <div className="flex gap-4">
            {(['twitter', 'instagram', 'linkedin'] as const).map((social) => (
              <a
                key={social}
                href="#"
                className="text-gray-400 transition-colors hover:text-white"
                aria-label={social}
              >
                <SocialIcon type={social} />
              </a>
            ))}
          </div>
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()} Run2Sale. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
